import React from 'react';
import { BookmarkCard } from '@/components/BookmarkCard';
import { type Bookmark } from '@/types/index';

interface BookmarksGridProps {
  bookmarks: Bookmark[];
  searchQuery: string;
  onEdit: (bookmark: Bookmark) => void;
  onDelete: (id: string) => void;
  onClearSearch: () => void;
  editMode?: 'edit' | 'delete' | null;
}

export function BookmarksGrid({
  bookmarks,
  searchQuery,
  onEdit,
  onDelete,
  onClearSearch,
  editMode,
}: BookmarksGridProps) {
  return (
    <>
      {/* Bookmarks Grid */}
      {bookmarks.length > 0 ? (
        <div className="flex flex-wrap space-x-2 space-y-2 justify-evenly py-4">
          {bookmarks.map((bookmark) => (
            <BookmarkCard
              key={bookmark.id}
              bookmark={bookmark}
              onEdit={onEdit}
              onDelete={onDelete}
              editMode={editMode}
            />
          ))}
        </div>
      ) : searchQuery ? (
        <div className="text-center py-20">
          <p className="text-gray-500 sm:text-[#edecec]/40 font-mono text-sm">
            Nothing found for "{searchQuery}"
          </p>
          <button
            onClick={onClearSearch}
            className="mt-4 text-xs text-gray-400 hover:text-gray-900 sm:text-[#edecec]/30 sm:hover:text-[#edecec] transition-colors underline underline-offset-4"
          >
            Clear search
          </button>
        </div>
      ) : null}
    </>
  );
}
